import React from "react";
import "./Stylesheets/App.css";
// import CodeNinjasReel from "./Components/CodeNinjasReel";
// import CenterCube from "./Components/CenterCube";
// import FilmstripScene from "./Components/FilmstripScene";
// import GameBuildAd from "./Components/GameBuildAd";
// import BackToSchoolAd from "./Components/BackToSchoolAd";
// import NewspaperPressAd from "./Components/NewspaperPressAd";
// import GoogleReviewsAd from "./Components/GoogleReviewsAd";
// import JoinUsAd from "./Components/JoinUsAd";
// import SummerCamp2026Ad from "./Components/SummerCamp2026Ad";
// import SummerCampWoodbridgeAd from "./Components/SummerCampWoodbridgeAd";
// import StaplesPromoAd from "./Components/StaplesPromoAd";
// import BestInvestmentAd from "./Components/BestInvestmentAd";
// import TwoSummersAd from "./Components/TwoSummersAd";
// import GroupChatAd from "./Components/GroupChatAd";
// import GameByKidAd from "./Components/GameByKidAd";
// import StaplesPowerUpAd from "./Components/StaplesPowerUpAd";
// import StaplesLockupAd from "./Components/StaplesLockupAd";
// import TechTalkAd from "./Components/TechTalkAd";
// import StaplesPosterInStore from "./Components/StaplesPosterInStore";
// import MapleBackToSchoolAd from "./Components/MapleBackToSchoolAd";
// import OpenHouseAd from "./Components/OpenHouseAd";
// import FinalWeekCampAd from "./Components/FinalWeekCampAd";
// import RhFiftyReviewsAd from "./Components/RhFiftyReviewsAd";
// import ScreenTimeReportAd from "./Components/ScreenTimeReportAd";
// import BuildFromCodeAd from "./Components/BuildFromCodeAd";
// import MarkDropAd from "./Components/MarkDropAd";
// import VendingSchedule from "./Components/VendingSchedule";
// import NetflixSchedule from "./Components/NetflixSchedule";
// import WheelSchedule from "./Components/WheelSchedule";
// import MapleThreeThousandAd from "./Components/MapleThreeThousandAd";
// import MapleSummitAd from "./Components/MapleSummitAd";
// import MapleDominoAd from "./Components/MapleDominoAd";
// import MapleMatAd from "./Components/MapleMatAd";
import MapleBullseyeAd from "./Components/MapleBullseyeAd";
// import MapleBulletAd from "./Components/MapleBulletAd";
// import MapleViceAd from "./Components/MapleViceAd";
// import MapleGameAd from "./Components/MapleGameAd";
// import MapleSpartanAd from "./Components/MapleSpartanAd";
// import MaplePirateAd from "./Components/MaplePirateAd";
// import MapleNavyAd from "./Components/MapleNavyAd";
import MapleStrikeAd from "./Components/MapleStrikeAd";

function App() {
  // return <WheelSchedule day="Thursday" />;
  // Maple Jiu Jitsu hits 3,000 followers. ?theme=night | ?theme=paper
  // return <MapleThreeThousandAd />;
  // Climb to 3,000, find more mountains. ?theme=sunrise | dusk
  // return <MapleSummitAd />;
  // 3,000 followers as a domino run. ?render=1 for tools/record-frames.js
  // return <MapleDominoAd />;
  // 3,000 followers on one mat, from above. ?render=1 for tools/record-frames.js
  // return <MapleMatAd />;
  // An arrow, a bullseye, 3,000 followers. ?render=1 for tools/record-frames.js
  // return <MapleBullseyeAd />;
  // 3,000 followers shot into steel. ?render=1 for tools/record-frames.js
  // return <MapleBulletAd />;
  // A Maple commercial, Vice City trailer style. ?render=1 for tools/record-frames.js
  // return <MapleViceAd />;
  // A Maple commercial as open-world game footage. ?render=1 for tools/record-frames.js
  // return <MapleGameAd />;
  // A 300-style Spartan charge. ?render=1 for tools/record-frames.js
  // return <MapleSpartanAd />;
  // A Jolly Roger, then the whole ship. ?render=1 for tools/record-frames.js
  // return <MaplePirateAd />;
  // Second act: the Maple warship runs in on the pirate. ?render=1
  // return <MapleNavyAd />;
  // Third act: the destroyer sinks the pirate. ?render=1
  return <MapleStrikeAd />;
}
export default App;
